module.exports = __webpack_public_path__ + "static/img/login_form_bg.19ef495a.png";